export default __webpack_public_path__ + "static/pharma1-76f4ca61530e594b2f57fa59420afb69.png";